"use strict";
const fp_1 = require("lodash/fp");
// NOTE: Ensures the car and home sub routes stay in sync
const buildCarAndHomeSubUrls = () => (0, fp_1.reduce)((result, insuranceType) => {
    const urls = (0, fp_1.reduce)((acc, page) => (0, fp_1.set)((0, fp_1.toUpper)((0, fp_1.snakeCase)(`${insuranceType}_${page}`)), `/${insuranceType}/${page}`, acc), {}, ['contact-us', 'login', 'quote', 'success']);
    return (0, fp_1.assign)(result, urls);
}, {}, ['car-insurance', 'home-insurance']);
module.exports = {
    ABOUT: '/about',
    AGR_FORM: '/agr-form',
    BASIC_DETAILS: '/basic-details',
    BUY: '/health-insurance/buy',
    BUY_ABOUT: '/health-insurance/buy/about',
    BUY_AGR: '/health-insurance/buy/agr',
    BUY_COVER: '/health-insurance/buy/cover',
    BUY_EMAIL: '/health-insurance/buy/email',
    BUY_PAYMENT: '/health-insurance/buy/payment',
    BUY_SUCCESS: '/health-insurance/buy/success',
    CAR_AND_HOME_INSURANCE_PRIVACY_POLICY: '/car-and-home-insurance/privacy-policy',
    CAR_INSURANCE: '/car-insurance',
    CHOOSABLE_PICKER: '/choosable/picker',
    CHOOSE_YOUR_COVER: '/health-insurance/choose-your-cover',
    CONTACT_US: '/contact-us',
    DIRECT_DEBIT_SERVICE_AGREEMENT: '/direct-debit-request-service-agreement',
    DOWNLOADS: '/forms-guides',
    ERROR_404: '/404',
    ERROR_500: '/500',
    EXPLAINED: '/explained',
    EXPLAINED_APPLE_CARD: '/explained/apple-card',
    EXPLAINED_DENTAL_AND_ORTHODONTICS: '/explained/dental-and-orthodontics',
    EXPLAINED_EXTRAS_COVER: '/explained/extras-cover',
    EXPLAINED_GETTING_THE_MOST_OUT_OF_PRIVATE_HOSPITAL_COVER: '/explained/getting-the-most-out-of-private-hospital-cover',
    EXPLAINED_HEALTH_INSURANCE_EXPLAINED: '/explained/health-insurance-explained',
    EXPLAINED_JOIN_DIRECT: '/explained/join-direct',
    EXPLAINED_POLICY_LIMITS: '/explained/health-insurance-limits',
    EXPLAINED_SWITCHING: '/explained/switching',
    EXPLAINED_WAITING_PERIODS: '/explained/waiting-periods',
    EXPLAINED_WHAT_IS_EXTRAS_COVER: '/explained/what-is-extras-cover',
    EXPLAINED_WHAT_IS_PRIVATE_HOSPITAL_COVER: '/explained/what-is-private-hospital-cover',
    EXPRESSED_CONSENT: '/consent',
    FIND_HEALTH_INSURANCE: '/find-health-insurance',
    FIND_HEALTH_INSURANCE_ALL: '/find-health-insurance/all',
    GOODLIFE: '/perks/goodlife',
    HEALTH_INSURANCE: '/health-insurance',
    HEALTH_INSURANCE_ALL: '/health-insurance/all',
    HELP: '/help',
    HOME: '/',
    HOME_INSURANCE: '/home-insurance',
    INCOME_INSURANCE: '/income-protection-insurance',
    LIFE_INSURANCE: '/life-insurance',
    LIFE_INSURANCE_CLAIM: '/life-insurance/claim',
    LIFE_INSURANCE_CONTACT_US: '/life-insurance/contact-us',
    LIFE_INSURANCE_HELP: '/life-insurance/help',
    LIFE_INSURANCE_HELP_AND_SUPPORT: '/life-insurance/help-and-support',
    LIFE_INSURANCE_USEFUL_DOCUMENTS: '/life-insurance/useful-documents',
    LIVEPERSON_UNAUTHENTICATED: '/msg',
    MAINTENANCE: '/maintenance',
    MEDIA_LANDING: '/health-insurance/join',
    NEEDS_JOURNEY_BARE_BONES: '/health-insurance/bare-bones-cover',
    NEEDS_JOURNEY_EXTRAS: '/health-insurance/extras-cover',
    NEEDS_JOURNEY_FAMILY: '/health-insurance/family-cover',
    NEEDS_JOURNEY_FIND_BARE_BONES: '/find-health-insurance/bare-bones-cover',
    NEEDS_JOURNEY_FIND_DECIDE_EXTRAS_COVER: '/find-health-insurance/decide-extras-cover',
    NEEDS_JOURNEY_FIND_EXTRAS: '/find-health-insurance/extras-cover',
    NEEDS_JOURNEY_FIND_FAMILY: '/find-health-insurance/family-cover',
    NO_GAP_DENTAL: '/health-insurance/no-gap/dental',
    OFFERS_HOME: '/perks',
    OFFERS_HOYTS: '/perks/hoyts',
    OFFER_FRIEND: '/offer/friend',
    OFFER_FRIEND_SHORT: '/r',
    OFFER_HOME: '/offer',
    OFFER_HOME_SHORT: '/o',
    OFFER_PICKLEBALL: '/perks/pickleball',
    OFFER_REFER: '/offer/refer',
    PREGNANCY: '/pregnancy',
    PRIVACY: '/privacy-policy',
    PRODUCT: '/health-insurance/:type/:id',
    PRODUCT_LISTING: '/health-insurance',
    PRODUCT_LISTING_EXTRAS: '/health-insurance/extras-cover/all',
    PRODUCT_LISTING_EXTRAS_ADD: '/health-insurance/extras-cover/all/add',
    PRODUCT_LISTING_HOSPITAL: '/health-insurance/hospital-cover/all',
    PRODUCT_LISTING_HOSPITAL_ADD: '/health-insurance/hospital-cover/all/add',
    PRODUCT_LISTING_PACKAGES: '/health-insurance/hospital-extras-packages/all',
    QUICK_QUOTE: '/quick-quote',
    READING_TAX_STATEMENT: '/reading-tax-statement',
    REFINE_PRICE: '/refine-price',
    SECURITY_AND_PRIVACY_HUB: '/security-privacy',
    SECURITY_POLICY: '/security-policy',
    SERVICE: '/service',
    SITEMAP: '/sitemap',
    SPECSAVERS: '/perks/specsavers',
    TAX: '/tax',
    TELSTRA_OFFER: '/perks/telstra',
    TERMS_AND_CONDITIONS: '/terms-and-conditions',
    TRAVEL_FORMS_AND_GUIDES: '/travel-insurance/forms-and-guides',
    TRAVEL_INSURANCE: '/travel-insurance',
    TRAVEL_INSURANCE_CONTACT_US: '/travel-insurance/contact-us',
    TRAVEL_INSURANCE_MAKE_A_CLAIM: '/travel-insurance/claim',
    TRAVEL_INSURANCE_WIDGET: '/travel-insurance/widget',
    YOUTH_DISCOUNT: '/youth-discount',
    ...buildCarAndHomeSubUrls(),
};
